import { getStyleDeclaration } from './get-style-declaration.js';
import { parentActiveState, parentHoverState, widgetSelector } from './helpers';

export function pollOptionWidget(widgetDescription) {
  const { placements = [], styledStates } = widgetDescription;
  const selector = widgetSelector(widgetDescription);

  const aspectRatio = `${widgetDescription.width}/${widgetDescription.height}`;

  const rules = [
    ...placements.map(getStyleDeclaration.positions(selector)),
    ...placements.map(getStyleDeclaration.size(selector)),
    [selector, [['aspect-ratio', aspectRatio]]],
    // fallback for aspect-ratio
    /*
    [ selector, [
      ['position', 'static' ],
    ], `@supports not (aspect-ratio: ${aspectRatio})`],
*/
    // disable aspect ratio polyfill due to its conflict with outline styles,
    // in case test will be passed, we can completely remove this polyfill

    [
      `${selector}::before`,
      [
        ['content', '""'],
        ['width', '1px'],
        ['margin-left', '-1px'],
        ['float', 'left'],
        ['height', '0'],
        ['padding-top', `calc(${aspectRatio} * 100%)`],
      ],
      `@supports not (aspect-ratio: ${aspectRatio})`,
    ],
    [
      `${selector}::after`,
      [
        ['content', '""'],
        ['display', 'table'],
        ['clear', 'both'],
      ],
      `@supports not (aspect-ratio: ${aspectRatio})`,
    ],
  ];

  if (styledStates) {
    const { default: base, hover, click: active } = styledStates;

    const bgSelector = `#bg-layer-fill_${widgetDescription.id}`;

    rules.push([bgSelector, [['background-color', base.fillColor]]]);
    rules.push([bgSelector, [['transition', 'background-color 250ms ease']]]);

    rules.push([
      parentHoverState(selector, bgSelector),
      [['background-color', hover.fillColor]],
    ]);

    rules.push([
      parentActiveState(selector, bgSelector),
      [['background-color', active.fillColor]],
    ]);
  }

  rules.push([`.mobile ${selector}`, [['min-height', 'initial']]]);

  return rules;
}
